import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { fetchPlansByPage } from 'api';
import { filterParamsForAttPlans } from 'helpers/plans';
import SubNav from 'components/SubNav';
import Spinner from 'components/Spinner';
import StartSwitchFormAttToSprint from 'components/StartSwitchFormAttToSprint';

export default class StartSwitchToSprint extends Component {
  constructor(props) {
    super(props);

    this.startSwitchAttToSprint = this.startSwitchAttToSprint.bind(this);
    this.fetchAllPlans = this.fetchAllPlans.bind(this);

    this.state = {
      error: null,
      successMsg: '',
      sprintSub: null,
      attPlans: [],
      showLoader: false,
    };
  }

  componentDidMount() {
    this.fetchAllPlans();
  }

  get redirectLink() {
    const { sub } = this.props;
    return `/att/subscriptions/${sub.id}/view`;
  }

  get attRedirectLink() {
    const { sprintSub } = this.state;
    return `/subscriptions/${sprintSub.id}/view`;
  }

  get isSuccess() {
    const { successMsg } = this.state;
    return successMsg === 'Success';
  }

  get initialValues() {
    const {
      sub: {
        device_id,
        icc_id,
        pin: account_pin,
        plan: { id: plan_id },
      },
    } = this.props;

    return { plan_id, device_id, icc_id, account_pin };
  }

  async startSwitchAttToSprint(payload) {
    const {
      startSwitchAttToSprint,
      sub: { id },
    } = this.props;

    this.setState({ showLoader: true });
    const response = await startSwitchAttToSprint(id, payload);

    if (response.status === 200) {
      this.setState({
        error: null,
        successMsg: 'Success',
        sprintSub: response.data,
      });
    } else {
      this.setState({ error: response.response.data, successMsg: '' });
    }
    this.setState({ showLoader: false });
  }

  async fetchAllPlans(page = 1) {
    try {
      const response = await fetchPlansByPage(page);

      if (response.status === 200) {
        const filteredPlans = response.data.results.filter((plan) => {
          return !filterParamsForAttPlans.some((param) =>
            plan.name.includes(param),
          );
        });

        this.setState({ attPlans: [...this.state.attPlans, ...filteredPlans] });
        if (response.data.next) this.fetchAllPlans(++page);
      }
    } catch (error) {
      this.setState({ error: error.response.data });
    }
  }

  render() {
    const { sub } = this.props;

    if (!sub) {
      return <div>Loading...</div>;
    }

    if (!sub.plan) {
      return (
        <React.Fragment>
          <SubNav />
          <Link to={this.redirectLink}>Back to subscription page</Link>
        </React.Fragment>
      );
    }

    const { error, successMsg, attPlans, showLoader } = this.state;

    return (
      <div style={{ position: 'relative' }}>
        <h1>Switch from AT&amp;T to Sprint</h1>
        <SubNav />
        <br />
        <StartSwitchFormAttToSprint
          subId={sub.id}
          errorMsg={error}
          successMsg={successMsg}
          attPlans={attPlans}
          initialValues={this.initialValues}
          onSubmit={this.startSwitchAttToSprint}
        />
        <br />
        {this.isSuccess && (
          <p>
            <Link to={this.attRedirectLink}>
              Go to Sprint subscription page
            </Link>
          </p>
        )}
        <Link to={this.redirectLink}>Back to subscription page</Link>
        <Spinner showLoader={showLoader} />
      </div>
    );
  }
}
